import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo/icon-h.svg';
import Child from '../../components/form/Child';
import Job from '../../components/form/Job';
import { api_url, headers } from '../../common/config';
import Loader from 'react-loader-spinner';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobs: '',
            ar_jobTitle: '',
            ar_jobDesc: '',
            en_jobTitle: '',
            en_jobDesc: '',
        };
    }
    componentDidMount() {
        if (this.props.job === true) {
            fetch(
                `${api_url}/autism/items/jobs/${this.props.match.params.id}`,
                {
                    method: 'GET',
                    // headers: headers,
                }
            )
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        jobs: res.data,
                        ar_jobTitle: res.data.ar_name,
                        ar_jobDesc: res.data.ar_description,
                        en_jobTitle: res.data.en_name,
                        en_jobDesc: res.data.en_description,
                    });
                });
        }
    }

    render() {
        const { t } = this.props;
        let type = this.props.match.params.type;
        return (
            <div className='form-container'>
                <div className='form-header'>
                    <Link to='/'>
                        <img src={logo} />
                    </Link>
                    <div
                        className='back'
                        onClick={() => {
                            this.props.history.goBack();
                        }}
                    >
                        <p>{t('back')}</p>
                    </div>
                </div>

                {this.props.child === true ? (
                    <>
                        <div className='form-title'>
                            <h1>{t('register.child.formTitle')}</h1>
                        </div>
                        <div className='form-body'>
                            <Child />
                        </div>
                    </>
                ) : (
                    <>
                        {this.state.jobDesc === '' &&
                        this.state.jobTitle === '' ? (
                            <div className='form-loader'>
                                <Loader
                                    type='Grid'
                                    color='#7670ff'
                                    height={100}
                                    width={100}
                                    timeout={15000} //5 secs
                                />
                            </div>
                        ) : (
                            <>
                                {i18next.language === 'ar' ? (
                                    <>
                                        {' '}
                                        <div className='form-title'>
                                            <h1>{this.state.ar_jobTitle}</h1>
                                        </div>
                                        <div className='form-body'>
                                            <Job
                                                jobTitle={
                                                    this.state.ar_jobTitle
                                                }
                                                jobDesc={this.state.ar_jobDesc}
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className='form-title'>
                                            <h1>{this.state.en_jobTitle}</h1>
                                        </div>
                                        <div className='form-body'>
                                            <Job
                                                jobTitle={
                                                    this.state.en_jobTitle
                                                }
                                                jobDesc={this.state.en_jobDesc}
                                            />
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        );
    }
}

export default withTranslation()(Form);
